/**
 * Price table by specialty type (in EUR)
 * These prices should match the backend healthQuestionary models
 */
const PRICE_TABLE = {
    'medecine-generale': 25,
    'dermatologie': 55,
    'auditif': 70,
    'ronflement': 99,
    'psychiatre': 50,
    'psychologie': 50,
    'gynecologie': 50,
    'acne': 50,
    'dentistry': 45,
    'traitement-anti-obesite': 50,
    'evaluation-nutritionnelle': 50,
    'postTeleconsultation': 0,
};

const DEFAULT_PRICE = 39;

/**
 * Get base price for a specialty type
 * @param {string} type - The specialty type (e.g., 'dermatologie', 'medecine-generale')
 * @returns {number} The base price in EUR
 */
export const getBasePrice = (type) => {
    return PRICE_TABLE[type] != null ? PRICE_TABLE[type] : DEFAULT_PRICE;
};

/**
 * Calculate turnover from aggregated request stats
 * Uses totalPaidAmount from backend when available, falls back to base prices
 * @param {Array} requests - Array of aggregated request stats from /requests/reqStat
 * @returns {number} Total turnover in EUR
 */
/**
 * Compute the EUR amount for one aggregated stat bucket (one {year,month,type}
 * group from /requests/reqStat). A bucket can contain both paid and unpaid
 * requests; sum the paid total plus the base-price estimate for the unpaid
 * remainder.
 */
export const bucketAmount = (bucket) => {
    if (!bucket) return 0;
    const paid = bucket.totalPaidAmount || 0;
    const unpaidCount = (bucket.count || 0) - (bucket.countWithPaidAmount || 0);
    const estimated = unpaidCount > 0 ? unpaidCount * getBasePrice(bucket._id?.type) : 0;
    return paid + estimated;
};

export const calculateTurnoverFromStats = (requests) => {
    if (!requests || !Array.isArray(requests)) return 0;

    return requests.reduce((acc, req) => {
        // Mixed buckets can have both paid (totalPaidAmount) and unpaid requests
        // (count - countWithPaidAmount). Sum both: paid amount + estimated value
        // of the unpaid remainder using the type's base price.
        const paid = req.totalPaidAmount || 0;
        const unpaidCount = (req.count || 0) - (req.countWithPaidAmount || 0);
        const estimated = unpaidCount > 0 ? unpaidCount * getBasePrice(req._id?.type) : 0;
        return acc + paid + estimated;
    }, 0);
};

export { PRICE_TABLE, DEFAULT_PRICE };
